import { defineComponent } from 'vue';
export default defineComponent({
    props: {
        textEn: {
            type: String,
            default: ''
        },
        textJp: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'white',
            validator: function (value) { return ['white', 'gray'].indexOf(value) >= 0; }
        }
    }
});
